import React, { createContext, useContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || "AIzaSyA5Ue5e_oiIAjIq_0OATLtYKiesn_3jh5c",
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || "pdv-orleans-dev.firebaseapp.com",
  databaseURL: process.env.FIREBASE_DATABASE_URL || "https://pdv-orleans-dev.firebaseio.com",
  projectId: process.env.FIREBASE_PROJECT_ID || "pdv-orleans-dev",
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || "pdv-orleans-dev.appspot.com",
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || "888297678864",
  appId: process.env.FIREBASE_APP_ID || "1:888297678864:web:6f0b929293657fc64c4295",
};

let app;
let auth;

if (typeof window !== "undefined") {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
}

const defaultContext = { currentUser: null }
const AuthContext = createContext(defaultContext);
export const useAuth = () => useContext(AuthContext);
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        setCurrentUser(user);
      }
    });
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </AuthContext.Provider>
  );
};
